// 首頁狀態摘要卡（對齊 Android `HomeStatusSummaryCard` / iOS `statusSummaryCard`，業主 2026-09-10「web 的家比照 app」）。
// 「我家現在怎麼樣」是首頁第一眼要回答的問題：全在線 → 一行「一切正常」；有離線 → 琥珀底 +
// 「N 台裝置離線」，卡片可展開直接列出是哪幾台（點進去就是離線排解的目的地），不丟一句數字
// 讓使用者自己去攝影機 Tab 一台一台找。預設展開（2026-08-24 設計評分：「哪幾台」不該多藏一次點擊）。
// 資料全部來自已載入的裝置清單，零後端成本。

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { deviceName, deviceStateLabel, tileState, type DeviceSummary } from '../devices/deviceModel';

export function HomeStatusSummary({ devices }: { devices: DeviceSummary[] }) {
  const { t } = useTranslation();
  const offline = devices.filter((d) => tileState(d) === 'offline');
  const total = devices.length;
  const off = offline.length;
  const [expanded, setExpanded] = useState(true);
  const headline = off === 0 ? t('home.statusAllOk') : t('home.statusOfflineCount', { count: off });
  const detail = off === 0 ? t('home.statusDetailAllOnline', { count: total }) : t('home.statusDetailMixed', { total, online: total - off });
  const HeadTag = off > 0 ? 'button' : 'div';

  return (
    <section className={`card home-status${off > 0 ? ' home-status-warn' : ''}`} data-testid="home-status-summary" aria-label={headline}>
      <HeadTag
        className="home-status-head"
        {...(off > 0 ? { type: 'button' as const, onClick: () => setExpanded((v) => !v), 'aria-expanded': expanded } : {})}
      >
        <span className="home-status-icon" aria-hidden>{off === 0 ? '✓' : '!'}</span>
        <span className="home-status-text">
          <span className="home-status-headline">{headline}</span>
          <span className="text-secondary home-status-detail">{detail}</span>
        </span>
        {off > 0 && <span className="home-status-chevron" aria-hidden>{expanded ? '▴' : '▾'}</span>}
      </HeadTag>
      {off > 0 && expanded && (
        <ul className="home-status-list" aria-label={t('home.statusOfflineCount', { count: off })}>
          {offline.map((d) => (
            <li key={d.device_id}>
              <Link to={`/devices/${encodeURIComponent(d.device_id)}`} className="home-status-row" data-testid={`home-status-offline-${d.device_id}`}>
                <span className="home-status-dot" aria-hidden />
                <span className="home-status-name">{deviceName(d)}</span>
                <span className="text-secondary home-status-state">{deviceStateLabel(d)}</span>
                <span className="home-status-arrow" aria-hidden>›</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
